// src/features/equipment/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import EquipmentListPage from './pages/EquipmentListPage';
import EquipmentDetailsPage from './pages/EquipmentDetailsPage';
import EditEquipmentPage from './pages/EditEquipmentPage';
import EquipmentTemplateSelectionPage from './pages/EquipmentTemplateSelectionPage';
import CreateEquipmentPage from './pages/CreateEquipmentPage';

export const EquipmentRoutes = () => (
  <Route path="equipment">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="equipment:read">
          <EquipmentListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="select-template"
      element={
        <ProtectedRoute requiredScope="equipment:create">
          <EquipmentTemplateSelectionPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="equipment:create">
          <CreateEquipmentPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":equipmentId"
      element={
        <ProtectedRoute requiredScope="equipment:read">
          <EquipmentDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":equipmentId/edit"
      element={
        <ProtectedRoute requiredScope="equipment:update">
          <EditEquipmentPage />
        </ProtectedRoute>
      }
    />
  </Route>
);